import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {wasteGenerators} from "../../../api/api-endpoints"

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        operation_day: '',
        billing_account_id: '',
        comment: '',
        value: '',
        _legal_id: '',
        _inn: '',
        _fio: '',
        _address: ''
      }
    }
  },
  methods: {
    /**
     * @override
     */
    getSuccessTitle () {
      return null
    },
    closeForm () {
      this.$refs.modalForm.redirectToPrev()
    },
    suggestionAccountsEndpoint (ctx, q) {
      return wasteGenerators.bankBooks({query: {number: q, 'per-page': 50}})
    },
    transformAccountsSuggestions (ctx, data) {
      return data.data.map(item => {
        if (item.legal_id) {
          return {id: item.id, name: `${item.number || ''}, ${item.name || '-'}, ИНН: ${item.inn || '-'}`, item}
        }
        return {id: item.id, name: `${item.number || ''}, ${item.fio|| '-'}, ${item.address || '-'}`, item}
      })
    },
    selectAccountsItem ($event) {
      if ($event && $event.id) {
        this.fields.billing_account_id = $event.id
        this.fields.billingAccountName = $event.item.number || ''
        this.fields._fio = $event.item.name || '-'
        this.fields._address = $event.item.address || '-'
        this.fields._inn = $event.item.inn || '-'
        this.fields._legal_id = $event.item.legal_id
      } else {
        this.fields.billing_account_id = ''
        this.fields.billingAccountName = ''
        this.fields._fio = ''
        this.fields._address = ''
        this.fields._inn = ''
        this.fields._legal_id = ''
      }
    }
  }
}
